import React from 'react';
import Customer from '@/components/customer';

export default () => <Customer />;
